(ns app.front.view.case-description.case-description
  (:require [app.domain.group.permit-type-config.model :as ptc-model]
            [app.domain.workspace.model :as workspace-model]
            [app.front.process :as process]
            [app.front.ui :as ui]
            [app.front.ui.rich-text :as ui-rt]
            [app.front.view.case-description.subs :as desc-subs]
            [app.front.view.workspace.section :as ws-section]
            [app.front.view.workspace.subs :as ws-subs]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.icons :as i]
            [core.util.util :as util]
            [reagent.core :as r]))

(defn description-editor [{:keys [tr class target authority-group description-sub edited-description-key]}]
  (r/with-let [*cancel-count (r/atom 0)]
    (let [case-description?  (= edited-description-key :description)
          signal             (if case-description? :process.signal/set-case-description :process.signal/set-case-description-of-location)
          can-set-desc?      (<sub [::process/signal-permitted? target [signal]])
          description        (<sub description-sub)
          edited-description (<sub [::desc-subs/edited-description edited-description-key])
          editing?           (<sub [::desc-subs/editing? edited-description-key])]
      [:div.p-4.rounded-md.bg-gray-200.mt-2 {:class class}
       ^{:key (str (name edited-description-key) "-text-editor-v-" @*cancel-count)}
       [ui-rt/editor-legacy (merge {:initial-value      description
                                    :id                 (str (name edited-description-key) "-text-editor")
                                    :authority-group-id (:db/id authority-group)}
                                   (when editing?
                                     {:on-change #(>evt [::desc-subs/update-edited-description edited-description-key %])}))]
       [:div.flex.justify-end
        (cond
          editing?
          [:div.mt-2
           (cc/button {:icon       i/remove
                       :type       :button
                       :kind       :secondary
                       :size       :field
                       :class-name "mr-2"
                       :on-click   #(do
                                      (swap! *cancel-count inc)
                                      (>evt [::desc-subs/clear-edited-description edited-description-key])
                                      (>evt [::desc-subs/disallow-editing edited-description-key]))}
                      (tr [:case/cancel]))
           (cc/button {:icon     i/check
                       :type     :button
                       :kind     :primary
                       :size     :field
                       :disabled (<sub [::desc-subs/description-save-disabled? edited-description-key])
                       :on-click #(when edited-description
                                    (>evt [::desc-subs/save-description
                                           target
                                           signal
                                           edited-description-key]))}
                      (tr [:case/save]))]

          can-set-desc?
          [:div.mt-2
           (cc/button {:icon     i/pen
                       :type     :button
                       :kind     :ghost
                       :size     :field
                       :on-click #(>evt [::desc-subs/allow-editing edited-description-key])}
                      (tr [:case/edit]))])]])))


(defn section []
  (let [tr                (<sub [::ws-subs/tr])
        target            (<sub [::ws-subs/execution])
        authority-group   (<sub [::ws-subs/authority-group])
        priorities        workspace-model/priorities
        selected-priority (or (<sub [::desc-subs/selected-priority])
                              (<sub [::desc-subs/saved-priority])
                              workspace-model/default-priority)
        can-set-prio?     (<sub [::process/signal-permitted? target [:process.signal/set-case-priority]])]
    [ws-section/section target :case/description-title {:tr tr} :case/description-title false
     [:div
      [:span (tr [:case/priority])]
      (if can-set-prio?
        (into
          [ui/select-pills {:on-change    #(>evt [::process/signal
                                                  target
                                                  [:process.signal/set-case-priority {:value %}]
                                                  {:on-success [::desc-subs/select-priority %]
                                                   :notify     {:success :case/priority-updated}}])
                            :value        selected-priority
                            :class        "mb-6"
                            :option-class "uppercase"}]
          (for [priority priorities]
            {:value priority
             :text  (tr [priority])}))
        [:div.font-bold.mt-2.mb-4 (tr [selected-priority])])

      [:label {:for "description-text-editor"} (tr [:case/description-title])]
      [description-editor (util/mmap
                            {:class                  "mb-6"
                             :description-sub        [::desc-subs/case-description]
                             :edited-description-key :description}
                            tr
                            target
                            authority-group)]

      (cc/checkbox {:id         "case-in-proximity"
                    :label-text (tr [:case/in-proximity])
                    :checked    (<sub [::desc-subs/saved-in-proximity])
                    :disabled   (not (<sub [::process/signal-permitted? target [:process.signal/set-case-in-proximity]]))
                    :on-change  #(>evt [::process/signal
                                        target
                                        [:process.signal/set-case-in-proximity {:value %}]
                                        {:notify {:success :case/in-proximity-updated}}])})
      (when (ptc-model/permit-types-with-non-owner-violation (<sub [::ws-subs/permit-type]))
        (cc/checkbox {:id         "case-non-owner-violation"
                      :label-text (tr [:case/non-owner-violation])
                      :checked    (<sub [::desc-subs/saved-non-owner-violation])
                      :disabled   (not (<sub [::process/signal-permitted? target [:process.signal/set-case-non-owner-violation]]))
                      :on-change  #(>evt [::process/signal
                                          target
                                          [:process.signal/set-case-non-owner-violation {:value %}]
                                          {:notify {:success :case/non-owner-violation-updated}}])}))
      (let [limited-visibility (<sub [::desc-subs/limited-visibility-for-other-departments])]
        ;; nil = not meaningful to show (no other departments to hide from and can't be set)
        (when (boolean? limited-visibility)
          (cc/checkbox {:id         "case-limited-visibility-checkbox"
                        :class-name "pb-6"
                        :label-text (tr [:group.config/limit-visibility-for-other-departments?])
                        :checked    limited-visibility
                        :disabled   (not (<sub [::process/signal-permitted?
                                                target
                                                [:process.signal/set-limited-visibility-for-other-departments]]))
                        :on-change  #(>evt [::process/signal
                                            target
                                            [:process.signal/set-limited-visibility-for-other-departments {:value %}]
                                            {:notify     {:success :case/limit-visibility-updated}
                                             :on-success [::desc-subs/toggle-limited-visibility-view-data]}])})))
      [:label {:for "description-of-location-text-editor"} (tr [:case/description-of-location-title])]
      [description-editor (util/mmap
                            {:description-sub        [::desc-subs/case-description-of-location]
                             :edited-description-key :description-of-location}
                            tr
                            target
                            authority-group)]]]))
